/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextBulletChecklistIcon20Light = forwardRef('TextBulletChecklistIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6.604 3.354a.5.5 0 1 0-.708-.708L3.5 5.043l-.896-.897a.5.5 0 1 0-.708.708l.897.896a1 1 0 0 0 1.414 0l2.397-2.396Z" }),
        React.createElement("path", { d: "M16.5 5h-8a.5.5 0 0 1 0-1h8a.5.5 0 0 1 0 1Z" }),
        React.createElement("path", { d: "M8.5 9a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1h-8Z" }),
        React.createElement("path", { d: "M16.5 14h-8a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1Z" }),
        React.createElement("path", { d: "M6.604 7.646a.5.5 0 0 1 0 .708L4.207 10.75a1 1 0 0 1-1.414 0l-.897-.896a.5.5 0 1 1 .708-.708l.896.897 2.396-2.397a.5.5 0 0 1 .708 0Z" }),
        React.createElement("path", { d: "M6.604 13.354a.5.5 0 0 0-.708-.708L3.5 15.043l-.896-.897a.5.5 0 0 0-.708.708l.897.896a1 1 0 0 0 1.414 0l2.397-2.396Z" })));
});
